export default __webpack_public_path__ + "static/media/7RW600.576eb240.png";